export default __webpack_public_path__ + "static/media/amaze-10.f26fd54f.jpg";